<template>
    <v-app>
       <!-- <head> <title>Greenapsis Smart CIties</title> </head> -->
        <!-- <v-col cols="12"> -->
            <sidebar
                v-if="logged"
                :drawer="drawer"
                @update-drawer="drawer = !drawer"
                @close-drawer="detectEvent" /> <!--Se añadio update-->
        <!-- </v-col> -->
        <!-- <v-col cols="12"> -->
            <navbar 
                v-if="logged"
                :drawer="drawer" 
                @update-drawer="drawer = !drawer"
                @close-drawer="detectEvent" /> <!--Se añadio close-->
            <v-main>
                <router-view class="container" />
            </v-main>
        <!-- </v-col> -->
    </v-app>
</template>

<script>
import { mapState } from 'vuex'
import navbar from './components/navigation/navbar'
import sidebar from './components/navigation/sidebar'

export default {
    name: 'App',
    components: {
        navbar,
        sidebar
    },
    computed:{
        ...mapState('user', {
            logged: state => state.logged
        })
    },
    data() {
        return {
            drawer: true,
            chartWidth: 0, //Added by Mariana
        }
    },
    methods: {
        detectEvent(value){
            this.drawer = value
            let name = this.$vuetify.breakpoint.name
            if(this.drawer){
                switch (name) {
                    case 'xs': this.chartWidth=350; break; //To be tested
                    case 'sm': this.chartWidth=350; break; //To be tested
                    case 'md': this.chartWidth=350; break;
                    case 'lg': this.chartWidth=350; break;
                    default: this.chartWidth=350; break;
                }
            }else{
                switch (name) {
                    case 'xs': this.chartWidth=400; break; //To be tested
                    case 'sm': this.chartWidth=400; break; //To be tested
                    case 'md': this.chartWidth=400; break;
                    case 'lg': this.chartWidth=400; break;
                    default: this.chartWidth=400; break;
                }
            }
            // console.log(name)
            // console.log('Width:',this.$vuetify.breakpoint.width)
        }
    },
    // mounted(){
    //     this.$root.$on('App', () => {
    //         this.detectEvent(value)
    //     })
    // }
};
</script>

<style scope>
.container{
    background-color: var(--v-background-base);
    min-height: 100%;
    min-width: 100%;
}

.v-card{
    border-radius: 10px !important;
}
</style>